import React from 'react';
import Radio from './Radio';

interface RadioOption {
  value: string;
  label: string;
  disabled?: boolean;
}

interface RadioGroupProps {
  name: string;
  value: string;
  onChange: (value: string) => void;
  options: RadioOption[];
  labelVariant?: 'body' | 'body-small' | 'body-small-bold';
  className?: string;
  style?: React.CSSProperties;
}

const RadioGroup: React.FC<RadioGroupProps> = ({
  name,
  value,
  onChange,
  options,
  labelVariant = 'body',
  className,
  style
}) => {
  return (
    <div className={`radio-group ${className || ''}`} style={style}>
      {options.map((option, index) => (
        <Radio
          key={option.value}
          name={name}
          value={option.value}
          checked={value === option.value}
          onChange={() => onChange(option.value)}
          label={option.label}
          labelVariant={labelVariant}
          disabled={option.disabled}
          id={`${name}-${option.value}`}
        />
      ))}
    </div>
  );
};

export default RadioGroup; 